<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="center">
      <el-form :model="userData" label-position="right" size="mini" style="width:30%">
        <!-- <el-form-item label="用户编号">
          <span>111</span>
        </el-form-item> -->
        <el-form-item label="账号">
          <span>{{userData.phone}}</span>
        </el-form-item>
        <el-form-item label="用户类型">
          <span>{{userData.userType}}</span>
        </el-form-item>
        <!-- <el-form-item label="账号状态">
          <span>111</span>
        </el-form-item>
        <el-form-item label="注册时间">
          <span>111</span>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userData: {},
      user: {},
    }
  },
  created() {
    this.user = this.$route.query
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        key: this.user.key,
        id: this.user.id,
      }

      this.HttpService.get(`/autoapp-recovery-server-auth/api/recoveryUser/getUserImportById?key=${this.user.key}&id=${this.user.id}`, params).then(res => {

        this.userData = res.data
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.content {
  margin-bottom: 30px;
  & .title {
    display: inline-block;
  }
  & .value {
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/userCheck.vue